import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getChitPostingList } from "../../actions/chitPosting.action.js";

export function useChitPostingGridData({
  filterParameters,
  dataState,
  refresh,
  currentComponent,
  onDataReceived,
}) {
  const dispatch = useDispatch();
  const onDataReceivedRef = useRef(onDataReceived);
  onDataReceivedRef.current = onDataReceived;
  const fetchGenerationRef = useRef(0);

  useEffect(() => {
    const generation = ++fetchGenerationRef.current;
    const page = dataState.skip / dataState.take + 1;
    const take = dataState.take;
    const sort = dataState.sort?.[0];

    let cancelled = false;

    (async () => {
      const result = await dispatch(
        getChitPostingList(
          page,
          take,
          filterParameters,
          currentComponent,
          sort,
        ),
      );
      if (cancelled || generation !== fetchGenerationRef.current) {
        return;
      }
      if (result != null && onDataReceivedRef.current) {
        onDataReceivedRef.current(result);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    dispatch,
    filterParameters,
    dataState.skip,
    dataState.take,
    dataState.sort,
    refresh,
    currentComponent,
  ]);
}
